<template>
  <div class="parent-box">
    <transition name="modal">
      <div class="">
        <div class="modal-wrapper">
          <br />
          <br />

          <div class="modal-container">
            <div class="modal-header">
              <h1 class="close-btn" @click="$emit('close')">Close</h1>
            </div>
            <div class="modal-body">
              <div class="heading">
                <h2 class="login-title">RePayment Information</h2>
              </div>
              <table class="table table-bordered">
                <!-- <div class="close-btnn">
                  <button class="submit-button">Download</button>
                </div>
                <br />
                <br />
                <br /> -->

                <tr>
                  <th class="text-nowrap mr-5">Monthly Charge</th>
                  <th class="text-nowrap mr-5 go-right text-left pr-5">
                    Repayment Date
                  </th>
                  <th
                    class="text-nowrap mr-5 go-righty"
                    style="margin-right: 60px"
                  >
                    Outstanding Balance
                  </th>
                  <th class="text-nowrap mr-5 go-righty text-left">
                    Outstanding Tenure
                  </th>
                  <th class="text-nowrap">Payment status</th>
                </tr>
                <!-- <tr v-for="item in tableDatas" :key="item.id"> -->
                <tr>
                  <td class="mr-5 text-nowrap text-center">
                    NGN{{
                      Intl.NumberFormat("en-US").format(
                        Number(tableDatas.monthlyCharge)
                      )
                    }}
                  </td>
                  <td class="mr-5 text-nowrap text-center">
                    {{
                      tableDatas.startingDate
                        ? new Date(tableDatas.startingDate).toLocaleDateString(
                            undefined,
                            dateOptions
                          )
                        : ""
                    }}
                  </td>
                  <td class="mr-5 text-nowrap text-center">
                    NGN{{
                      Intl.NumberFormat("en-US").format(
                        tableDatas.totalPayableAmount -
                          Number(tableDatas.initialPaymentAmount)
                      )
                    }}
                  </td>
                  <td class="mr-5 text-nowrap text-center">
                    {{ Number(tableDatas.tenure) - 1 }} Months
                  </td>
                  <td class="mr-5 text-nowrap">
                    {{ tableDatas.initialPaymentMade ? "Paid" : "Not Paid" }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ArnergyInput from "../ArnergyInput";
import ArnergySelect from "../AnergySelectDynamic.vue";
import Agreement from "./Agreement";
import axios from "axios";
export default {
  name: "Modal",
  props: {
    productDetails: null,
    titleProduct: null,
    amt: null,
    desc: null,
    tableDatas: null
  },
  components: {
    ArnergyInput,
    ArnergySelect,
    Agreement
  },
  computed: {},
  data() {
    return {
      costShow: false,
      showAgreement: false,
      ctn: false,
      message: "",
      activeIndex: 0,
      sucessMsg: false,
      errorMessage: false,
      BT: [
        { id: "Oil & Gas", name: "Oil & Gas" },
        { id: "Farmer", name: "Farmer" },
        { id: "Driver", name: "Driver" },
        { id: "Painter", name: "Painter" }
      ],
      employmentStatus: [
        { id: "Employed", name: "Employed" },
        { id: "Self Employed", name: "Self Employed" }
      ],
      incomes: [
        { id: "< N500,000", name: " < N500,000" },
        { id: ">N500,000 and < N750,000", name: ">N500,000 and < N750,000" },
        {
          id: "> N750,000 and < N1,000,000",
          name: "> N750,000 and < N1,000,000"
        },
        { id: "> N1,000,000", name: "> N1,000,000" }
      ],
      tenures: [{ id: null, name: null }],
      amountToPay: {},
      products: [],
      loader: false,
      form: {
        tenure: "",
        income: "",
        employment: "",
        business: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {},
      dateOptions: {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric"
      }
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },

  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    },
    async fetchAll() {
      console.log(this.productDetails);
      // parse for "arnergy-select" use
      this.products = this.productDetails;
    },
    getAmtofTenure(id) {
      let obj = this.tenures.find(x => x.id == id);
      this.amountToPay = obj;
    },
    finalReq() {
      const HTTP = this.$httpUtils.instance;

      localStorage.amtPay = this.amountToPay.caution;
      localStorage.amtRepay = this.amountToPay.monthly;

      console.log("set the new amt is " + this.amountPay.caution);

      const data = {
        customerId: localStorage.customerId,
        productid: this.amountToPay.productID,
        tenure: this.amountToPay.name,
        firstPaymentAmt: this.amountToPay.monthly,
        recurrentMonthlyAmt: this.amountToPay.caution,
        employmentStatus: this.form.employment,
        monthlyIncomeRange: this.form.income,
        typeOfBusiness: this.form.business
      };
      this.loader = true;
      HTTP.post(`/CustomerProductOptions/saveCustomerOption`, data)
        .then(res => {
          if (res.data.status) {
            this.loader = false;
            this.message = res.data.message;
            this.errorMessage = false;
            this.sucessMsg = true;
            this.ctn = true;
          } else {
            this.message = res.data.message;
            this.errorMessage = true;
            this.loader = false;
            this.sucessMsg = false;
            setTimeout(() => {
              window.location.href = "/onboarding";
            }, 2000);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  async mounted() {
    console.log(this.tableDatas);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

.modal-mask {
  margin-top: 30px;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.amt {
  font-size: 20px;
  color: $secondary-color;
  font-weight: bold;
}

.info-below {
  font-size: 16px;
  font-weight: 900;
}

.info-footer {
  float: left;
  margin-bottom: 3rem;
}

.modal-container {
  width: 990px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  height: 90vh;
  overflow-y: scroll;

  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

table,
td {
  border: 1px solid #000;
}

.modal-header {
  margin-top: 0;
  color: #42b983;
  position: relative;
  .close-btn {
    color: orangered;
    font-size: 16px;
    position: absolute;
    top: 0;
    right: 0;
  }
}

.modal-body {
  margin: 20px 0;
}

.close-btnn {
  color: orangered;
  font-size: 16px;
  position: absolute;
  top: 0;
  right: 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: right;
  padding: 10px 22px;
  margin-top: 120px;
  border: 0;
  margin-right: 15px;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.go-righty {
  margin-right: "50px" !important;
}

.go-right {
  margin-right: "180px" !important;
}

.link {
  color: $primary-color;
  font-weight: bold;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  color: $primary-color;
}

.submit-gif {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  color: white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/TableModal.vue